import React, { useEffect } from 'react';
import {
    Datagrid,
    TextField,
    ShowButton,
    ReferenceManyField,
    Pagination,
    useListContext,
} from 'react-admin';
import { ReferenceField } from 'react-admin';
import { DateField } from 'react-admin';

const DatagridWithTotal = props => {
    const { total, loaded } = useListContext();

    return (
        <>
            {loaded && (
                <div
                    style={{
                        padding: '16px',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: 'rgba(0, 0, 0, 0.87)',
                    }}
                >
                    Total Communications: {total || 0}
                </div>
            )}
            <Datagrid>
                <TextField source="serial" sortable={false} />
                <TextField source="id" label="Communication Id" />
                <TextField source="taskStatus" label="Task Status" />
                <TextField source="taskType" label="Task Type" />
                <TextField source="templateName" label="Template Name" />
                <TextField source="senderEmail" label="Sender Email" />
                <TextField source="recipientEmail" label="Recipient Email" />
                <TextField source="channel" label="Channel" />
                <TextField source="deliveryStatus" label="Delivery Status" />
                <DateField
                    locales="en-IN"
                    source="sendDate"
                    label="Send Date"
                    showTime
                />
                <ShowButton />
            </Datagrid>
            <Pagination />
        </>
    );
};

export const UserCommunicationsList = props => {
    useEffect(() => {
        localStorage.setItem(
            'currentComMod',
            `/users/${props.record.id}/show/8`
        );
    }, []);
    return (
        <ReferenceManyField
            reference="Communication-records"
            target="recipientId"
            perPage={25}
            filter={{ recipientId: props.record.id }}
            {...props}
        >
            <DatagridWithTotal />
        </ReferenceManyField>
    );
};
